/* Head close-ups.
   The page is already complete without this: every "Head" panel shows a
   centre crop of the product photo. This refines that crop by finding the
   thickest part of the mallet (the head) with a two-pass chamfer distance
   transform on a small canvas, then framing there. If a crop was already
   baked into the markup, that one is kept. */
(function () {
  var panels = document.querySelectorAll(".emg-head[data-src]");
  if (!panels.length || !window.HTMLCanvasElement) return;

  function focus(el) {
    if (el.style.backgroundPosition && el.style.backgroundPosition !== "") return;
    var src = el.getAttribute("data-src");
    if (!src) return;
    var img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = function () {
      try {
        var N = 110, c = document.createElement("canvas");
        c.width = c.height = N;
        var g = c.getContext("2d", { willReadFrequently: true });
        g.fillStyle = "#fff"; g.fillRect(0, 0, N, N);
        g.drawImage(img, 0, 0, N, N);
        var d = g.getImageData(0, 0, N, N).data;
        var D = new Float32Array(N * N), i, x, y;
        for (i = 0; i < N * N; i++) {
          var mn = Math.min(d[i * 4], d[i * 4 + 1], d[i * 4 + 2]);
          D[i] = (255 - mn > 22) ? 1e6 : 0;
        }
        function at(x, y) { return (x < 0 || y < 0 || x >= N || y >= N) ? 0 : D[y * N + x]; }
        for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
          i = y * N + x; if (!D[i]) continue;
          D[i] = Math.min(D[i], at(x - 1, y) + 1, at(x, y - 1) + 1, at(x - 1, y - 1) + 1.4, at(x + 1, y - 1) + 1.4);
        }
        for (y = N - 1; y >= 0; y--) for (x = N - 1; x >= 0; x--) {
          i = y * N + x; if (!D[i]) continue;
          D[i] = Math.min(D[i], at(x + 1, y) + 1, at(x, y + 1) + 1, at(x + 1, y + 1) + 1.4, at(x - 1, y + 1) + 1.4);
        }
        var max = 0, mi = -1;
        for (i = 0; i < N * N; i++) if (D[i] < 1e5 && D[i] > max) { max = D[i]; mi = i; }
        if (max < 2.5 || mi < 0) return;
        /* Average only the thick pixels NEAR the thickest one. A mallet with a
           head at each end has two peaks, and averaging both lands the crop on
           the bare shaft between them. */
        var px = mi % N, py = (mi / N) | 0, R = N * 0.22;
        var sx = 0, sy = 0, n = 0;
        for (y = 0; y < N; y++) for (x = 0; x < N; x++) {
          var v = D[y * N + x];
          if (v < 1e5 && v >= max * 0.9 &&
              Math.abs(x - px) <= R && Math.abs(y - py) <= R) { sx += x; sy += y; n++; }
        }
        if (!n) { sx = px; sy = py; n = 1; }
        var zoom = Math.min(6, Math.max(2.2, N / (max * 7)));
        /* background-position aligns the image's p% point with the box's p%
           point, so the feature's own position is not the value we want: solve
           for the p that puts the feature in the middle of the box. */
        function place(f) {
          var v = (f * zoom - 0.5) / (zoom - 1);
          return (Math.max(0, Math.min(1, v)) * 100).toFixed(1);
        }
        el.style.backgroundSize = (zoom * 100).toFixed(0) + "%";
        el.style.backgroundPosition =
          place(sx / n / N) + "% " + place(sy / n / N) + "%";
      } catch (err) { /* tainted canvas or decode failure: keep the centre crop */ }
    };
    img.src = src.replace(/&amp;/g, "&").replace(/width=\d+/, "width=420");
  }

  for (var k = 0; k < panels.length; k++) focus(panels[k]);
})();

/* Click a photo to enlarge it. The photos are ordinary links to the
   full-size image, so without JavaScript they still open it; this
   intercepts the click and shows it in an overlay instead. */
(function () {
  var lb = document.getElementById("emg-lb");
  if (!lb) return;
  var box = lb.querySelector(".emg-lb-box"),
      imgEl = document.getElementById("emg-lb-img"),
      capEl = document.getElementById("emg-lb-cap"),
      linkEl = document.getElementById("emg-lb-link"),
      closeBtn = document.getElementById("emg-lb-x"),
      last = null;

  function open(shot) {
    var url = shot.getAttribute("href");
    imgEl.style.backgroundImage = "url('" + url + "')";
    if (shot.getAttribute("data-view") === "head") {
      imgEl.style.backgroundSize = shot.style.backgroundSize || "cover";
      imgEl.style.backgroundPosition = shot.style.backgroundPosition || "center";
    } else {
      imgEl.style.backgroundSize = "contain";
      imgEl.style.backgroundPosition = "center";
    }
    capEl.textContent = shot.getAttribute("data-cap") || "";
    linkEl.setAttribute("href", shot.getAttribute("data-url") || "#");
    last = shot;
    lb.hidden = false;
    document.documentElement.style.overflow = "hidden";
    closeBtn.focus();
  }

  function close() {
    lb.hidden = true;
    document.documentElement.style.overflow = "";
    if (last) { last.focus(); last = null; }
  }

  document.addEventListener("click", function (ev) {
    var shot = ev.target.closest && ev.target.closest(".emg-shot");
    if (shot) { ev.preventDefault(); open(shot); return; }
    if (ev.target.hasAttribute && ev.target.hasAttribute("data-close")) close();
  });
  closeBtn.addEventListener("click", close);
  document.addEventListener("keydown", function (ev) {
    if (lb.hidden) return;
    if (ev.key === "Escape") { close(); return; }
    if (ev.key === "Tab") {
      var f = box.querySelectorAll("a[href], button");
      if (!f.length) return;
      var first = f[0], lastF = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === first) { ev.preventDefault(); lastF.focus(); }
      else if (!ev.shiftKey && document.activeElement === lastF) { ev.preventDefault(); first.focus(); }
    }
  });
})();